export class NavigationConstant {
  // constant for routeLink
  public static DEV                   = 'team-re.103.10.130.53.xip.io';
  public static LOCAL                 = 'localhost';
  public static REGRESSION            = 're-bo-ui';
  public static SIT                   = 'dev.dokupay.com';
  public static SANDBOX               = 'staging.doku.com';
  public static PRODUCTION            = 'bo.doku.com';

  public static HOME = '';
  public static HOME_REDIRECT = '/integration/simulator';
  public static HOME_BO = '/bo/integration/simulator';
  public static INQUIRY = '/inquiry';
  public static PAYMENT = '/payment';
  public static PAYMENT_RESULT = '/payment-result';

  public static BNI_SNAP_INQUIRY = 'bni-snap/inquiry';
  public static BNI_SNAP_PAYMENT = 'bni-snap/payment';
  public static BNI_SNAP_PAYMENT_RESULT = 'bni-snap/payment-result';

  public static MANDIRI = 'mandiri';
  public static MANDIRI_INQUIRY = 'mandiri/inquiry';
  public static MANDIRI_PAYMENT = 'mandiri/payment';
  public static MANDIRI_PAYMENT_RESULT = 'mandiri/payment-result';

  public static MANDIRI_SNAP_INQUIRY = 'mandiri-snap/inquiry';
  public static MANDIRI_SNAP_PAYMENT = 'mandiri-snap/payment';
  public static MANDIRI_SNAP_PAYMENT_RESULT = 'mandiri-snap/payment-result';

  public static PERMATA = 'permata';
  public static PERMATA_INQUIRY = 'permata/inquiry';
  public static PERMATA_PAYMENT = 'permata/payment';
  public static PERMATA_PAYMENT_RESULT = 'permata/payment-result';

  public static BCA = 'bca';
  public static BCA_INQUIRY = 'bca/inquiry';
  public static BCA_PAYMENT = 'bca/payment';
  public static BCA_PAYMENT_RESULT = 'bca/payment-result';

  public static OVO_INQUIRY = 'ovo/inquiry';
  public static OVO_PAYMENT = 'ovo/payment';
  public static OVO_PAYMENT_RESULT = 'ovo/payment-result';

  public static DANAMON_INQUIRY = 'danamon/inquiry';
  public static DANAMON_PAYMENT = 'danamon/payment';
  public static DANAMON_PAYMENT_RESULT = 'danamon/payment-result';

  public static BRISYARIAH_INQUIRY = 'bri-syariah/inquiry';
  public static BRISYARIAH_PAYMENT = 'bri-syariah/payment';
  public static BRISYARIAH_PAYMENT_RESULT = 'bri-syariah/payment-result';

  public static DOKUVA_INQUIRY = 'doku-va/inquiry';
  public static DOKUVA_PAYMENT = 'doku-va/payment';
  public static DOKUVA_PAYMENT_RESULT = 'doku-va/payment-result';

  public static MANDIRISYARIAH_INQUIRY = 'mandiri-syariah/inquiry';
  public static MANDIRISYARIAH_PAYMENT = 'mandiri-syariah/payment';
  public static MANDIRISYARIAH_PAYMENT_RESULT = 'mandiri-syariah/payment-result';

  public static ALFA_INQUIRY = 'alfa/inquiry';
  public static ALFA_PAYMENT = 'alfa/payment';
  public static ALFA_PAYMENT_RESULT = 'alfa/payment-result';

  public static INDOMARET_INQUIRY = 'indomaret/inquiry';
  public static INDOMARET_PAYMENT = 'indomaret/payment';
  public static INDOMARET_PAYMENT_RESULT = 'indomaret/payment-result';

  public static BRI_INQUIRY = 'bri/inquiry';
  public static BRI_PAYMENT = 'bri/payment';
  public static BRI_PAYMENT_RESULT = 'bri/payment-result';

  public static BRI_SNAP_INQUIRY = 'bri-snap/inquiry';
  public static BRI_SNAP_PAYMENT = 'bri-snap/payment';
  public static BRI_SNAP_PAYMENT_RESULT = 'bri-snap/payment-result';

  public static BTN_INQUIRY = 'btn/inquiry';
  public static BTN_PAYMENT = 'btn/payment';
  public static BTN_PAYMENT_RESULT = 'btn/payment-result';

  public static BNI_INQUIRY = 'bni/inquiry';
  public static BNI_PAYMENT = 'bni/payment';
  public static BNI_PAYMENT_RESULT = 'bni/payment-result';

  public static BNC_PAYMENT = 'bnc/payment';
  public static BNC_INQUIRY = 'bnc/inquiry';
  public static BNC_PAYMENT_RESULT = 'bnc/payment-result';

  public static SHOPEEPAY_PAYMENT_RESULT = 'shopeepay/payment-result';

  public static LINKAJA_IDENTIFY = 'linkaja/identify';
  public static LINKAJA_LOGIN = 'linkaja/login';
  public static LINKAJA_PAYMENT = 'linkaja/payment';
  public static LINKAJA_PAYMENT_RESULT = 'linkaja/payment-result';

  public static UNAUTHORIZED = 'unauthorized/';

  public static DANAMON_SNAP_INQUIRY = 'danamon-snap/inquiry';
  public static DANAMON_SNAP_PAYMENT = 'danamon-snap/payment';
  public static DANAMON_SNAP_PAYMENT_RESULT = 'danamon-snap/payment-result';

  public static PERMATA_SNAP_INQUIRY = 'permata-snap/inquiry';
  public static PERMATA_SNAP_PAYMENT = 'permata-snap/payment';
  public static PERMATA_SNAP_PAYMENT_RESULT = 'permata-snap/payment-result';

  public static MAYBANK_SNAP_INQUIRY = 'maybank-snap/inquiry';
  public static MAYBANK_SNAP_PAYMENT = 'maybank-snap/payment';
  public static MAYBANK_SNAP_PAYMENT_RESULT = 'maybank-snap/payment-result';

  public static KLIK_BCA_INQUIRY = 'klik-bca/inquiry';
  public static KLIK_BCA_PAYMENT = 'klik-bca/payment';
  public static KLIK_BCA_PAYMENT_RESULT = 'klik-bca/payment-result';

  public static BSI_SNAP_INQUIRY = 'bsi-snap/inquiry';
  public static BSI_SNAP_PAYMENT = 'bsi-snap/payment';
  public static BSI_SNAP_PAYMENT_RESULT = 'bsi-snap/payment-result';

}
